const DAY_IN_MILLISECONDS = 86_400_000;

const parseUtcDate = (value: string) => {
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;

  const date = new Date(Date.UTC(year, month - 1, day));
  return Number.isNaN(date.getTime()) ? null : date;
};

/** Counts hotel nights using checkout as the non-billable boundary. */
export function countHotelNights(checkInDate: string, checkOutDate: string | null | undefined): number {
  if (!checkOutDate) return 0;

  const checkIn = parseUtcDate(checkInDate);
  const checkOut = parseUtcDate(checkOutDate);
  if (!checkIn || !checkOut) return 0;

  const difference = Math.floor((checkOut.getTime() - checkIn.getTime()) / DAY_IN_MILLISECONDS);
  return Math.max(0, difference);
}
